var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showOptions)?_c('div',{staticClass:"options-popup",style:({ top: _vm.position.y + 'px', left: _vm.position.x + 'px' })},[_c('div',{staticClass:"options-list"},_vm._l((_vm.options),function(option,index){return _c('div',{key:option.id,staticClass:"option-item",on:{"click":function($event){return _vm.selectOption(option,index)}}},[_vm._v("\n      "+_vm._s(option.name)+"\n    ")])}),0)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1524e64e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/discuss/options-popup.vue
// module id = 1003
// module chunks = 0